// Generated by BUCKLESCRIPT VERSION 2.2.2, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Board = require("./board");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Player = require("./player");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var Caml_exceptions = require("bs-platform/lib/js/caml_exceptions.js");

var CantSwitchPlayer = Caml_exceptions.create("Game.CantSwitchPlayer");

var InsolubleGame = Caml_exceptions.create("Game.InsolubleGame");

function currentPlayer(game) {
  return Caml_array.caml_array_get(game[/* players */1], game[/* playerIndex */2]);
}

function init(players) {
  return /* record */[
          /* board */Board.init(8, 8),
          /* players */players,
          /* playerIndex */0,
          /* finished : false */0
        ];
}

function playerCanPlay(game, playerIndex) {
  var color = /* Some */[Caml_array.caml_array_get(game[/* players */1], playerIndex)[/* color */1]];
  var match = Board.availableCellChanges(game[/* board */0], color);
  if (match) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function switchPlayer(game) {
  var match = +(game[/* playerIndex */2] === 1);
  var nextPlayerIndex = match !== 0 ? 0 : 1;
  var match$1 = playerCanPlay(game, nextPlayerIndex);
  if (match$1 !== 0) {
    return /* record */[
            /* board */game[/* board */0],
            /* players */game[/* players */1],
            /* playerIndex */nextPlayerIndex,
            /* finished */game[/* finished */3]
          ];
  } else {
    var match$2 = playerCanPlay(game, game[/* playerIndex */2]);
    if (match$2 !== 0) {
      throw [
            CantSwitchPlayer,
            game
          ];
    } else {
      throw [
            InsolubleGame,
            /* record */[
              /* board */game[/* board */0],
              /* players */game[/* players */1],
              /* playerIndex */game[/* playerIndex */2],
              /* finished : true */1
            ]
          ];
    }
  }
}

function applyCellClick(game, x, y) {
  var color = /* Some */[currentPlayer(game)[/* color */1]];
  var board = Board.applyCellChange(game[/* board */0], /* record */[
        /* x */x,
        /* y */y,
        /* color */color
      ]);
  var match = Board.getCountForColor(board, /* None */0);
  if (match !== 0) {
    return switchPlayer(/* record */[
                /* board */board,
                /* players */game[/* players */1],
                /* playerIndex */game[/* playerIndex */2],
                /* finished */game[/* finished */3]
              ]);
  } else {
    return /* record */[
            /* board */game[/* board */0],
            /* players */game[/* players */1],
            /* playerIndex */game[/* playerIndex */2],
            /* finished : true */1
          ];
  }
}

function locationReload() {
  return ( window.location.reload() );
}

function reducer(action, state) {
  if (action) {
    var exit = 0;
    var game;
    try {
      game = applyCellClick(state[/* game */0], action[0], action[1]);
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn === Board.InvalidMove) {
        return /* Update */Block.__(0, [/* record */[
                    /* game */state[/* game */0],
                    /* message : Some */["Invalid Move"]
                  ]]);
      } else if (exn[0] === InsolubleGame) {
        return /* Update */Block.__(0, [/* record */[
                    /* game */exn[1],
                    /* message : Some */["No One Can Play"]
                  ]]);
      } else if (exn[0] === CantSwitchPlayer) {
        return /* Update */Block.__(0, [/* record */[
                    /* game */exn[1],
                    /* message : Some */["Opponent can't play, play again!"]
                  ]]);
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      return /* Update */Block.__(0, [/* record */[
                  /* game */game,
                  /* message : None */0
                ]]);
    }
    
  } else {
    return /* SideEffects */Block.__(2, [locationReload]);
  }
}

var component = ReasonReact.reducerComponent("Game");

function make(game, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2];
      var message = match[/* message */1];
      var game = match[/* game */0];
      var messageElement = message ? message[0] : null;
      var match$1 = game[/* finished */3];
      return React.createElement("div", {
                  className: "game"
                }, messageElement, ReasonReact.element(/* None */0, /* None */0, Board.make(game[/* board */0], (function (param) {
                            return Curry._1(self[/* send */4], /* Click */[
                                        param[/* x */0],
                                        param[/* y */1]
                                      ]);
                          }), /* array */[])), React.createElement("div", {
                      className: "players"
                    }, $$Array.mapi((function (i, player) {
                            return ReasonReact.element(/* Some */[Pervasives.string_of_int(i)], /* None */0, Player.make(player, +(game[/* playerIndex */2] === i), /* array */[]));
                          }), game[/* players */1])), match$1 !== 0 ? React.createElement("div", {
                        className: "finished"
                      }, "Game Over", React.createElement("br", undefined), React.createElement("button", {
                            onClick: (function () {
                                return Curry._1(self[/* send */4], /* Restart */0);
                              })
                          }, "Start Another Game")) : null);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* game */game,
              /* message : None */0
            ];
    });
  newrecord[/* reducer */12] = reducer;
  return newrecord;
}

exports.CantSwitchPlayer = CantSwitchPlayer;
exports.InsolubleGame = InsolubleGame;
exports.currentPlayer = currentPlayer;
exports.init = init;
exports.playerCanPlay = playerCanPlay;
exports.switchPlayer = switchPlayer;
exports.applyCellClick = applyCellClick;
exports.locationReload = locationReload;
exports.reducer = reducer;
exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/game.re
// module id = 14
// module chunks = 0